<template>
	<div class="event-sub-dialog">
		<h2>Dettagli prenotazione</h2>

		<div class="user-info">
			<UserPicture class="picture" :src="'https://ui-avatars.com/api/?name=' + user.first_name + '+' + user.last_name + '&size=64&length=4&font-size=0.3'"/>
			<div>
				<div class="name">{{ [user.first_name, user.last_name].join(' ') }}</div>
				<div class="sub-date">{{ sub.created_at | moment('ddd D @ HH:mm') }}</div>
			</div>
		</div>

		<div class="manage-actions">
			<!-- Link per vedere le iscrizioni -->
			<button class="subscriptions-button" @click="goToSubscriptions">
				📅 Vedi iscrizioni alle Small Class
			</button>

		</div>

		<div class="products">
			<div class="loading" v-if="products === undefined">
				<LoadingWidget class="widget"></LoadingWidget>
			</div>
			<div class="list" v-else>
				<div v-if="subProduct" class="product selected"
					:class="productClasses(subProduct)"
					@click="() => attachProduct(null)">
					<div class="info">
						<div class="name">
							<div>{{ subProduct.name }}
								<small style="font-size: 0.8em; color: #999;">#{{ subProduct.id }}</small>
							</div>
							<div v-if="subProduct.size === 0 && isExpired(subProduct.expire_date)" class="badge badge-expired">Scaduto</div>
							<div v-else-if="subProduct.size === 0 && isExpiring(subProduct.expire_date)" class="badge">In Scadenza</div>
						</div>

						<div class="charges">
							<template v-if="subProduct.size === 0 && subProduct.expire_date">
								<div class="expiration">Scade il {{ formatDate(subProduct.expire_date) }}</div>
							</template>

							<template v-else>
								<div class="remaining">{{ subProduct.remaining || '-' }}</div>
								<div class="size">/{{ subProduct.size }}</div>
							</template>
						</div>
					</div>
				</div>

				<div v-for="prod in filterProducts" :key="prod.id"
					class="product"
					:class="[productClasses(prod), { selected: subProduct && subProduct.id === prod.id }]"
					@click="attachProduct(prod)"
				>
					<div class="info">
						<div class="name">
							<div>{{ prod.name }}
								<small style="font-size: 0.8em; color: #999;">#{{ prod.id }}</small>
								<button class="fas fa-trash" @click.stop="removeProduct(prod)"></button> <!-- ✅ nuovo -->
							</div>
							<div v-if="prod.size === 0 && isExpired(prod.expire_date)" class="badge badge-expired">Scaduto</div>
							<div v-else-if="prod.size === 0 && isExpiring(prod.expire_date)" class="badge">In Scadenza</div>
						</div>

						<div class="charges">
							<template v-if="prod.size === 0 && prod.expire_date">
								<div class="expiration">Scade il {{ formatDate(prod.expire_date) }}</div>
							</template>

							<template v-else>
								<div class="remaining">{{ prod.remaining || '-' }}</div>
								<div class="size">/{{ prod.size }}</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { api } from '@/api'
import { notif } from '@/pop'
import { pop } from '@/pop'

export default {
	name: 'EventSubDialog',

	props: {
		// Sub details
		sub: {
			type: Object,
			required: true
		}
	},

	data() {

		return {
			products: undefined,
			usedProductIds: new Set() // 👈 usato anche qui
		}
	},

	computed: {
		/**
		 *
		 */
		user() {

			return this.sub.user || null
		},

		/**
		 *
		 */
		subProduct() {

			return this.sub.product && this.products && this.products.find(({ id }) => id === this.sub.product)
		},

		/**
		 *
		 */
		filterProducts() {

			return this.products.filter(({ id }) => id !== this.sub.product)
		}
	},

	methods: {
		goToSubscriptions() {
			this.$emit('close'); // chiude la dialog
			this.$router.push({
				path: `/admin/users/${this.user.id}/subscriptions`,
				query: { name: this.user.first_name + ' ' + this.user.last_name }
			});
		},
		async removeProduct(prod) {
			try {
				const conferma = confirm(`Sei sicuro di voler cancellare il pacchetto "${prod.name}"?`);
				if (!conferma) return;

				await api.admin().removeProduct(this.user.id, prod.id);
				const idx = this.products.findIndex(p => p.id === prod.id);
				if (idx !== -1) this.$delete(this.products, idx);
				notif.done(`${prod.name} è stato rimosso`);
			} catch (err) {
				console.error(err);
				notif.error('Errore durante la rimozione del pacchetto');
			}
		},
		isExpiring(expirationDate) {
			if (!expirationDate) return false;
			const today = new Date();
			const expDate = new Date(expirationDate);
			const diffTime = expDate - today;
			const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
			return diffDays <= 7;
		},
		isExpired(expirationDate) {
			if (!expirationDate) return false;
			const today = new Date().setHours(0, 0, 0, 0);
			const exp = new Date(expirationDate).setHours(0, 0, 0, 0);
			return exp <= today;
		},
		productClasses(prod) {
			if (!prod) return '';

			const isUsed = this.usedProductIds.has(prod.id);

			if (prod.size === 0) {
				return {
					subscription: true,
					expiring: this.isExpiring(prod.expire_date),
					expiredSub: this.isExpired(prod.expire_date),
					used: isUsed
				};
			}

			return {
				expired: prod.remaining <= 0,
				used: isUsed
			};
		},
		formatDate(dateStr) {
			if (!dateStr) return '';
			const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
			return new Date(dateStr).toLocaleDateString('it-IT', options);
		},
		/**
		 *
		 */
		detachProduct() {
			if (!this.subProduct) return
			this.attachProduct(null)
		},

		async fetchProducts() {
			try {
				// Carica i prodotti
				const products = await api.user().getProducts(this.user.id);
				this.products = products;

				// Trova lunedì della settimana corrente
				const today = new Date();
				const day = today.getDay(); // 0 (dom) - 6 (sab)
				const monday = new Date(today);
				monday.setDate(today.getDate() - ((day + 6) % 7)); // lunedì

				// Trova domenica della prossima settimana
				const sundayNext = new Date(monday);
				sundayNext.setDate(monday.getDate() + 13); // domenica successiva

				const from_date = monday.toISOString().split('T')[0];
				const to_date = sundayNext.toISOString().split('T')[0];
				// Recupera prenotazioni nel range
				const subscriptions = await api.user().getSubscriptions(this.user.id, { from_date, to_date });

				// Estrai ID pacchetti usati
				const usedIds = new Set(
					subscriptions
						.filter(sub => sub.product !== null)
						.map(sub => sub.product)
				);

				this.usedProductIds = usedIds;

			} catch (err) {
				console.error(err);
				notif.error('Impossibile caricare la lista di pacchetti');
			}
		},

		/**
		 *
		 */
		async attachProduct(product) {
			try {
				const oldProduct = this.subProduct;

				// Chiamata API per assegnare nuovo prodotto (o null)
				const sub = await api.admin().attachProduct(this.user.id, this.sub.event, product ? product.id : null);

				// 🔁 Gestione visuale del conteggio lezioni
				if (oldProduct && oldProduct.id !== sub.product) {
					oldProduct.remaining++; // restituisco 1 lezione al vecchio pacchetto
				}

				if (product && (!oldProduct || product.id !== oldProduct.id)) {
					product.remaining--; // scala 1 al nuovo pacchetto selezionato
				}

				// Aggiorna la prenotazione con il nuovo prodotto
				this.$emit('sub', { ...this.sub, product: sub.product });

				// Aggiorna i prodotti
				this.fetchProducts();

			} catch (err) {
				console.error(err);
				notif.error('Errore durante l’assegnazione del pacchetto');
			}
		}
	},

	mounted() {

		this.fetchProducts()
	}
}
</script>

<style lang="stylus" scoped>
.event-sub-dialog
	.user-info
		display grid
		grid-template-columns auto 1fr
		align-items center
		grid-gap 1em

		.picture
			width 96px
			height 96px
		
		.name
			color secondary

			font-size 1.2em
			font-weight bold
		
		.sub-date
			color lightish

			font-size 0.9em
			font-style italic
	
	.products
		margin-top 2em

		.loading
			padding 2em

			.widget
				width 3em
				height 3em

				margin auto
		
		.list
			display grid
			grid-template-columns auto
			grid-gap 1em

			.product
				padding 1em
				border-radius 0.5em
				box-sizing border-box

				background-color darker

				cursor pointer

				.info
					display grid
					grid-template-columns 1fr auto
					align-items center

					.name
						color light

						font-size 1.4em
						font-weight bold
					
					.charges
						padding 1em
						border-left 2px solid secondary

						text-align center

						.remaining
							color secondary

							font-size 2em
							font-weight bold
				
				&.selected
					box-shadow 0 0 0 2px primary
					border 0px solid primary

					.name
						color primary

.product.subscription
	border 2px solid #00bcd4
	color light
	min-height 70px

	.name
		color light

	.charges
		border-left 2px solid #00bcd4

.product.expiring
	border 2px dashed #ffe010
	color light

	.name
		color orange

	.charges
		border-left 2px dashed #ffe010

.product.expiredSub
	border 2px solid crimson
	color mix(light, dark, 50%)

	.name
		color inherit

	.charges
		border-left 2px solid crimson

.badge
	background-color #ffe010
	color dark
	padding 0.2em 0.5em
	margin-top 0.5em
	border-radius 0.5em
	font-size 0.8em
	font-weight bold
	text-align center
	display inline-block

.badge-expired
	background-color crimson
	color light
	padding 0.2em 0.5em
	margin-top 0.5em
	border-radius 0.5em
	font-size 0.8em
	font-weight bold
	text-align center
	display inline-block

.expiration
	margin-top 0.5em
	font-size 0.9em
	color lightish

.fas.fa-trash
	background none
	border none
	color lightish
	cursor pointer
	margin-left 0.5em

	&:hover
		color crimson

.product.used
	box-shadow: 0 0 0 2px #8886
	background-color rgba(255, 255, 255, 0.05)

	.name::after
		content: ' • in uso'
		font-size: 0.7em
		color: secondary
		margin-left: 0.5em

.subscriptions-button
	display block
	text-align center
	background-color #ffe010
	color #232b34
	font-weight bold
	padding 0.8em 1em
	margin-top 1em
	border none
	text-decoration none
	cursor pointer
	transition background-color 0.2s ease

	&:hover
		background-color #d4ac0d

</style>
